import Vue from 'vue'
import Loading from './loading.vue'

Loading.newInstance = properties => {
  const _props = properties || {}

  const Instance = new Vue({
    data: Object.assign({}, _props, {
      visible: false
    }),
    render(h) {
      let vnode = ''
      if (this.render) {
        vnode = h(
          Loading,
          {
            props: {
              fix: true,
              fullscreen: true,
              fullscreenVisible: this.visible
            }
          },
          [this.render(h)]
        )
      } else {
        vnode = h(Loading, {
          props: {
            size: 'lg',
            fix: true,
            fullscreen: true,
            fullscreenVisible: this.visible
          }
        })
      }
      return h(
        'div',
        [vnode]
      )
    }
  })

  const component = Instance.$mount()
  document.body.appendChild(component.$el)
  const loading = Instance.$children[0]

  return {
    show() {
      Instance.visible = true
    },
    remove(cb) {
      Instance.visible = false
      setTimeout(function() {
        loading.$parent.$destroy()
        if (document.getElementsByClassName('loading-fullscreen').length > 0) {
          document.body.removeChild(
            document.getElementsByClassName('loading-fullscreen')[0]
          )
        }
        cb()
      }, 500)
    },
    component: loading
  }
}
export default Loading



// WEBPACK FOOTER //
// ./src/components/loading/loading.js